import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, ShieldCheck } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
const stack = ['PromptAdsPro — Software completo', '24 ángulos psicológicos pre-cargados', 'Generador de creativos multiformato', 'Guía de inicio rápido (30 min)', 'Actualizaciones gratuitas'];
export function OfferSection() {
  return <section id="oferta" className="bg-black py-16 px-4 relative overflow-hidden" data-id="element-85">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-1/2 bg-matrix-green/8 blur-[100px] pointer-events-none" data-id="element-86" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-87">
        <div className="text-center mb-8" data-id="element-88">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-4xl md:text-5xl font-black text-white mb-4" data-id="element-89">
            Todo lo que te llevás hoy
          </motion.h2>
          <p className="font-body text-gray-400 text-lg" data-id="element-90">
            El sistema definitivo para escalar tus campañas sin depender de la
            suerte.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mb-8" data-id="element-91">
          {/* 3D Cubes Image */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative rounded-2xl overflow-hidden border border-matrix-green/20 shadow-[0_0_30px_rgba(0,255,65,0.15)]" data-id="element-92">
            <div className="absolute inset-0 bg-matrix-green/5 mix-blend-overlay pointer-events-none" data-id="element-93" />
            <img src="https://i.postimg.cc/SxwJrH0g/portada-Hotmart-1.webp" alt="PromptAdsPro — Ebook Principal" className="w-full h-auto object-cover" data-id="element-94" />
          </motion.div>

          {/* Pricing & CTA */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-black p-8 md:p-12 rounded-3xl text-center border border-matrix-green/40 shadow-2xl relative glow-green-lg" data-id="element-95">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-matrix-green to-matrix-bright text-black font-bold font-mono px-6 py-2 rounded-full text-sm shadow-lg" data-id="element-96">
              OFERTA ESPECIAL
            </div>

            <div className="mb-4 mt-4" data-id="element-97">
              <span className="text-gray-500 line-through font-heading text-2xl" data-id="element-98">
                USD $160
              </span>
            </div>
            <div className="mb-10 flex items-center justify-center gap-3" data-id="element-99">
              <span className="font-heading font-black text-5xl md:text-7xl text-matrix-green text-glow-green" data-id="element-100">
                9.90USD
              </span>
            </div>

            <ul className="space-y-4 mb-10 text-left max-w-sm mx-auto" data-id="element-101">
              {stack.map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-102">
                  <CheckCircle2 className="w-6 h-6 text-matrix-green flex-shrink-0" data-id="element-103" />
                  <span className="font-body font-medium text-gray-200 text-lg" data-id="element-104">
                    {item}
                  </span>
                </li>)}
            </ul>

            <motion.a href="https://pay.hotmart.com/I104697906M" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
            content_name: 'PromptAdsPro',
            value: 9.9,
            currency: 'USD'
          })} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full relative inline-flex items-center justify-center gap-3 bg-matrix-green hover:bg-matrix-green-dark text-black font-heading font-bold text-2xl py-6 px-8 rounded-xl shadow-[0_10px_30px_rgba(0,255,65,0.4)] transition-all duration-300 pulse-glow" data-id="element-105">
              <Download className="w-7 h-7" data-id="element-106" />
              <span data-id="element-107">¡Quiero la Oferta!</span>
            </motion.a>

            <div className="mt-8 flex items-center justify-center gap-2 text-gray-400 text-sm font-body" data-id="element-108">
              <ShieldCheck className="w-5 h-5 text-matrix-green" data-id="element-109" />
              <span data-id="element-110">Garantía de 7 días. Riesgo cero.</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}